import ExportBase from "../exportbase";


import LabelDialog from "../../../../../dialogs/labeldialog";
import DialogInputBox from "../../../../../dialogs/inputbox";


import React from "react";

class ExportTXTMOSAIC extends ExportBase 
{


constructor(props)
{
    super(props);

    this.state.formulaire =
    {
        timecodeout: true,
        bom: true,
    }
        
    
    this.timecodeOutRef = React.createRef();
    this.bomRef = React.createRef();



    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)


    this.ready = false;
    this.lastFormulaireSend = "";

}

componentDidMount()
{
    super.componentDidMount();
    
    
}

componentDidUpdate()
{
    super.componentDidUpdate()
    
}

createWorker()
{
    
    return new Worker(new URL('./txtmosaicworker.js', import.meta.url));
}

sendFormulaire()
{
    
    var datas = {};
    datas = {
        timecodeout : this.timecodeOutRef.current.getValue(),
        bom:  this.bomRef.current.getValue(),
    }
    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
               this.lastFormulaireSend = JSON.stringify(datas);
            this.startComputeFile(datas)
    }

    
    
}


handleOnChange()
{
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{
   
    this.ready = true;

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>

    return super.render(

    <>
        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Type de fichier":"File type"}
        />

        <DialogInputBox
        value = {this.state.formulaire.timecodeout}
        disabled={false}
        autoFocus = {false}
        ref = {this.timecodeOutRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec time codes de fin":" With Out TimeCodes"}
        />

        <br/>
        <DialogInputBox
        value = {this.state.formulaire.bom}
        disabled={false}
        autoFocus = {false}
        ref = {this.bomRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec B.O.M.":" With B.O.M."}
        />


        <br/>

        <br/>
        
    </>
        
    )
}
}

export default ExportTXTMOSAIC;